import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I want to analyze your blog",
  "description": "",
  "published": "2011-09-30T00:00:00.000Z",
  "redirect_from": ["/blog/i-want-to-analyze-your-blog/swizec/2541"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Please send exports of your wordpress blogs to `}<a parentName="p" {...{
        "href": "mailto:swizec@swizec.com"
      }}>{`swizec@swizec.com`}</a>{`! For science!`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Screen-Shot-2011-10-01-at-1.48.03-AM-300x289.png",
        "alt": null,
        "title": "Word and sentence length"
      }}></img></p>
    <p>{`But a little background :)`}</p>
    <p>{`Lately I've been noticing a certain lack of the artsy side of life around me. It would seem that somehow despite being a great fan of theatre and real books and things of such nature I have slipped into a very techy existence where the closest I come to appreciating good art are the books laying around my desk waiting to be read since two years ago.`}</p>
    {
      /*more*/
    }
    <p>{`Being a man of a scientific bent I couldn't just make such claims without at least attempting to verify them. Plus it's a cool thing to do and I had a bit of time.`}</p>
    <p>{`Luckily for me, there's this brilliant dataset, a cool inside into my mind ... this blog. I started writing back when I was smack dab in the middle of my last year of high school - what I consider to be the height of my habit of regularly reading real books. With years this has slowly declined. The natural thing to do, therefore, was to see if this reflects in the way I write, which coincidentally reflects the way I think.`}</p>
    <p>{`It's the perfect experiment!`}</p>
    <p>{`A general decline of `}<em parentName="p">{`being well read`}</em>{` should reflect in my writing style. I tracked six parameters:`}</p>
    <ol>
      <li parentName="ol">{`Length of words - more syllables mean heavier, awesomer words`}</li>
      <li parentName="ol">{`Sentence length - longer sentences are a sign of not speaking like a marketer or the internet`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Flesch%E2%80%93Kincaid_readability_test",
          "title": "Flesch–Kincaid readability test"
        }}>{`Flesch-kincaid`}</a>{` - this is a measure of readability, or how educated one must be to understand your text`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://swizec.com/blog/measuring-vocabulary-richness-with-python/swizec/2528",
          "title": "Measuring vocabulary richness with python"
        }}>{`Yule's I`}</a>{` - this is a measure of vocabulary richness, where I'm assuming a broader `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Vocabulary",
          "title": "Vocabulary"
        }}>{`active vocabulary`}</a>{` is a positive thing`}</li>
      <li parentName="ol">{`Length - simple, how many words and how many sentences there are in a post`}</li>
    </ol>
    <p>{`The graphs are somewhat slow to load, `}<a parentName="p" {...{
        "href": "http://swizec.com/blog-analysis-charts/blog.html"
      }}>{`click here to see shiny graphs in full javascript glory`}</a>{`.`}</p>
    <p>{`For everyone else, here are some screenshots:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Screen-Shot-2011-10-01-at-1.48.03-AM-300x289.png",
        "alt": null,
        "title": "Word and sentence length"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/10/Screen-Shot-2011-10-01-at-1.48.19-AM-300x290.png",
        "alt": null,
        "title": "Readability"
      }}></img></p>
    <p>{`As you can see, the data is very squiggly, but there is no trend showing. The problem with this is that I just don't know how to draw a conclusion from these graphs. They seem to suggest that in five years of blogging I haven't progressed as a writer in the least bit.`}</p>
    <p>{`On the other hand they seem to suggest that despite four years of university education, my writing has stayed at a high school level, which seems to lend a credence of support to the original hypothesis.`}</p>
    <p>{`In order to better judge what's going on I need to compare data with other blogs. See if trends are cropping up anywhere at all. So please, if you have a wordpress blog, send me an export of your posts to `}<a parentName="p" {...{
        "href": "mailto:swizec@swizec.com."
      }}>{`swizec@swizec.com.`}</a>{` It's for science!`}</p>
    <p>{`And you get to show off some shiny graphs `}<em parentName="p">{`and`}</em>{` find out about how you stack up as a writer.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.itransition.com"
        }}>{`software development`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://shawndotbailey.wordpress.com/2011/09/09/literary-ekg/"
        }}>{`Literary EKG`}</a>{` (shawndotbailey.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://imittcopy.com/Thewhitepaperblog/how-to-check-the-readability-of-your-writing-with-microsoft-word/"
        }}>{`How to Check the Readability of Your Writing With Microsoft Word`}</a>{` (imittcopy.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://comprehension.prsa.org/?p=3335"
        }}>{`Can You Read Me Now? How to Make Your Copy More Accessible`}</a>{` (comprehension.prsa.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://smartwrite1.wordpress.com/2010/11/16/the-gunning-fog-index-what-it-means-for-your-writing/"
        }}>{`The Gunning FOG Index - What It Means For Your Writing`}</a>{` (smartwrite1.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=60fc6599-71f3-4078-91c7-0b47563bfad3",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      